import { createSignal } from "solid-js";
import { useUserContext } from "./UserContext";

interface ExternalNameFormProps {
  allowCASFallback?: boolean;
}

export default function ExternalNameForm(props: ExternalNameFormProps) {
  const [_userStore, _setUserStore, userActions] = useUserContext() as any;
  const [name, setName] = createSignal(localStorage.getItem('studentName') || '');
  const [error, setError] = createSignal<string | null>(null);
  const allowCASFallback = () => props.allowCASFallback ?? true;

  const submit = (e?: Event) => {
    e?.preventDefault();
    const trimmed = name().trim();
    if (!trimmed) {
      setError('Please enter your name');
      return;
    }
    if (trimmed.length > 50) {
      setError('Name is too long (max 50 characters)');
      return;
    }
    setError(null);
    userActions.submitExternalName(trimmed);
  };

  return (
    <form class="card p-3" onSubmit={submit}>
      <h5 class="card-title">Continue as Student</h5>
      <div class="mb-3">
        <label class="form-label">Your name</label>
        <input
          type="text"
          class="form-control"
          placeholder="Enter your name"
          value={name()}
          onInput={(e) => setName(e.currentTarget.value)}
          maxlength={50}
          autofocus
        />
        {error() && <div class="text-danger mt-1">{error()}</div>}
      </div>
      <div class="d-flex gap-2">
        <button type="submit" class="btn btn-primary">
          Continue
        </button>
        {allowCASFallback() && (
          <button type="button" class="btn btn-secondary" onClick={() => userActions.chooseCAS()}>
            Use CAS instead
          </button>
        )}
      </div>
      <div class="form-text mt-2">
        Your name will be visible to the teacher and used to attribute your answers.
      </div>
    </form>
  );
}
